import React, { type ReactElement } from 'react'
import { useTheme } from '@mui/material/styles'
import { Typography } from '@mui/material'
import inactiveAccountBackground from 'assets/inactiveAccountBackground.svg'
import ThemeButton from 'common/ui/theme-button'

import styles from '../inactive-account/InactiveAccount.module.scss'

const IncompleteAccount: React.FC = (): ReactElement => {
  const { palette } = useTheme()

  return (
    <div
      className={styles.container}
      style={{
        backgroundImage: `url(${inactiveAccountBackground})`,
        backgroundPosition: 'right',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div className={styles.content}>
        <div
          style={{
            height: '135px',
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: 'column',
          }}
        >
          <Typography variant="paragraph" sx={{ lineHeight: '26px' }}>
            Niste popunili sve potrebne podatke na CDT Companies aplikaciji i zato ste u nemogućnosti da
            pristupite Vendors aplikaciji. Da biste pristupili Vendors aplikaciji morate popuniti svoje
            podatke.
          </Typography>
        </div>
        <ThemeButton
          sx={{
            backgroundColor: palette.charts.green200.main,
            '&:hover': {
              backgroundColor: palette.charts.green200.main,
            },
          }}
          href="/kompanije"
        >
          POPUNI PODATKE
        </ThemeButton>
      </div>
    </div>
  )
}

export default IncompleteAccount
